import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const PathEditorContainer = styled.div`
  margin-top: 20px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 8px;
`;

const PathList = styled.div`
  margin-bottom: 15px;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const PathItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  
  &:hover {
    background-color: #e0e0e0;
  }
  
  &.selected {
    background-color: #d0d0d0;
  }
`;

const PathEditor = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px;
  font-family: monospace;
  resize: vertical;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
`;

const Button = styled.button`
  padding: 5px 10px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
  
  &:hover {
    background-color: #555;
  }
`;

const NoElements = styled.div`
  padding: 10px;
  color: #666;
  text-align: center;
`;

const PathEditorComponent = ({ svgCode, setSvgCode }) => {
  const [paths, setPaths] = useState([]);
  const [selectedPath, setSelectedPath] = useState(null);
  const [pathData, setPathData] = useState('');

  useEffect(() => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgCode, 'image/svg+xml');
      
      // Get all path elements
      const pathElements = [];
      const svgPaths = doc.querySelectorAll('path');
      
      svgPaths.forEach((path, index) => {
        pathElements.push({
          id: index,
          d: path.getAttribute('d'),
          element: path
        });
      });
      
      setPaths(pathElements);
      setSelectedPath(null);
      setPathData('');
    } catch (err) {
      console.error('Error parsing SVG paths:', err);
    }
  }, [svgCode]);

  const handlePathSelect = (path) => {
    setSelectedPath(path);
    setPathData(path.d);
  };

  const handlePathDataChange = (e) => {
    setPathData(e.target.value);
  };

  const handleApplyPath = () => {
    if (!selectedPath) return;
    
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgCode, 'image/svg+xml');
      
      // Find the path in the parsed document
      const svgPaths = doc.querySelectorAll('path');
      const targetPath = svgPaths[selectedPath.id];
      
      if (targetPath) {
        targetPath.setAttribute('d', pathData);
        setSvgCode(new XMLSerializer().serializeToString(doc));
      }
    } catch (err) {
      console.error('Error updating path data:', err);
    }
  };

  return (
    <PathEditorContainer>
      <h3>Path Editor</h3>
      <PathList>
        {paths.length > 0 ? (
          paths.map((path) => (
            <PathItem 
              key={path.id}
              className={selectedPath && selectedPath.id === path.id ? 'selected' : ''}
              onClick={() => handlePathSelect(path)}
            >
              Path {path.id + 1}
            </PathItem>
          ))
        ) : (
          <NoElements>No path elements found</NoElements>
        )}
      </PathList>
      
      {selectedPath && (
        <>
          <PathEditor 
            value={pathData}
            onChange={handlePathDataChange}
            placeholder="Path data (d attribute)"
          />
          <Button onClick={handleApplyPath}>Apply Changes</Button>
        </>
      )}
    </PathEditorContainer>
  );
};

export default PathEditorComponent; 